export default __webpack_public_path__ + "static/media/wa_2.6afbde14.mp3";